import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DaterangePickerComponent } from "src/app/components/ui/daterange-picker/daterange-picker.component";
import { DaterangePickerDirective } from "src/app/components/ui/daterange-picker/daterange-picker.directive";
import { DxDateRangeBoxModule } from "devextreme-angular";

@NgModule({
  imports: [CommonModule, DxDateRangeBoxModule],
  declarations: [DaterangePickerComponent, DaterangePickerDirective],
  exports: [DaterangePickerComponent]
})
export class DaterangePickerModule {}
